// extracted by mini-css-extract-plugin
export default {"SSOButton":"SSOLoginButton_SSOButton__TnT1P","loading":"SSOLoginButton_loading__5QGCu","msLogo":"SSOLoginButton_msLogo__MlIPM"};